import * as React from "react";
import {cx}       from "emotion";

import "./idml-upload-missing-fonts.scss";

import {ComponentLink,
        Link,
        makeChain}     from "@Common/react/cst2";
import {Types}         from "@Common/types";


export const IdmlUploadMissingFonts = ({
    missingFonts,
    onComplete,
}:{
    missingFonts  : any[],
    onComplete    : () => void,
}) => (

    makeChain<JSX.Element>()

    // render view
    .then(({}) => (
        <div className="idml-upload-missing-fonts-kd8">
            <div className="content">
                <h2>Your template uses unsupported fonts.</h2>
                <p>
                    We don't support the following fonts. You can{" "}
                    <a href="#new-template"
                        onClick={(e) => {e.preventDefault(); window.location.hash = "#new-template"}}
                    >return to upload</a> after adjusting your IDML to use one of our supported fonts or you may
                    continue to replace missing fonts with our default. You will be able to adjust font within our
                    editor.
                </p>
                <ol>
                    {missingFonts.map((font, index) => (
                        <li key={index}>
                            {font.fileName}
                        </li>
                    ))}
                </ol>
            </div>
            <div className="button-bar">
                <button className="upload-btn"
                    onClick={onComplete}
                    name="accept_continue"
                    xd-qa-type="button" xd-qa-name="New Template Upload Accept Fonts"
                >Accept & Continue</button>
            </div>
        </div>
    ))

    .run()

);
